import { Card, Col, Input, Label, Row } from "reactstrap";

import React, { useCallback, useEffect, useRef, useState } from "react";

import { useDispatch, useSelector } from "react-redux";
import { isEmpty } from "lodash";
import {
  getJobsOpenList,
  searchSingleJobFilesList,
  uploadJobFiles,
  uploadJobFilesSuccess,
} from "../../../store/jobsList/actions";
import { getAttachmentCategoryTypeData } from "../../../store/attachmentCategoryType/actions";
import Select from "../../Common/AppSelect";
import UploadFileOutlinedIcon from "@mui/icons-material/UploadFileOutlined";
import "../popupComponents.styles.scss";
import { toast } from "react-toastify";
import moment from "moment";
import { getSingleJobAttachmentURL } from "../../../store/singleJob/action";
import AppModal from "../../Common/AppModal";
import {
  uploadPurchaseDraft,
  uploadPurchaseDraftSuccess,
} from "../../../store/purchase/action";
import { searchTaskAttachmentList } from "../../../store/tasksCrmIT/action";
import { searchOpportunityAttachmentList } from "../../../store/opportunities/action";
import { searchSupplierAttachment } from "../../../store/supplier/action";
import {
  assetAttachmentSearch,
  assetRecentActivityList,
} from "../../../store/asset/action";
import {
  searchCompanyVehicleAttachment,
  listCompanyVehicleRecentActivity,
} from "../../../store/companyVehicle/action";
import {
  foodPreOrderEventAttachmentSearch,
  foodPreOrderEventRecentActivityList,
} from "../../../store/foodPreOederEvent/action";
import {
  searchBankAccountAttachment,
  searchBankAccountStatement,
} from "../../../store/bank/action";

const formatBytes = (bytes) => {
  const n = Number(bytes);
  if (!n || n < 0) return "";
  if (n < 1024) return `${n} B`;
  if (n < 1024 * 1024) return `${(n / 1024).toFixed(1)} KB`;
  return `${(n / (1024 * 1024)).toFixed(1)} MB`;
};

export default function UploadMultipleFiles({
  modal,
  setModal,
  toggle,
  singleJobAttachment,
  page,
  callBack,
  taskDetailsAttachment, // <-- pass params.id here when uploading from task
  opportunityDetailsAttachment, // <-- pass params.id here when uploading from opportunity
  supplierDetailsAttachment, // <-- pass params.id here when uploading from supplier
  companyVehicleDetailsAttachment, // <-- pass params.id here when uploading from company vehicle
  assetDetailsAttachment, // <-- pass params.id here when uploading from an asset (Task 24446)
  foodPreOrderEventDetailsAttachment, // <-- pass params.id here when uploading from a pre-order event
  bankAccountDetailsAttachment, // <-- pass params.id here when uploading a general document (letter, overdraft request) from a bank account
  bankAccountStatementDetailsAttachment, // <-- pass params.id here when uploading a bank statement (with a period) from a bank account
}) {
  const dispatch = useDispatch();

  const jobMultipleFilesInit = [];
  const [jobMultipleFiles, setJobMultipleFiles] =
    useState(jobMultipleFilesInit);

  // Change #100009: "Link a Job" used to load every job via /job/list, which
  // runs out of memory on a large company (COMPANY_4, ~60k jobs) and 500s,
  // leaving the picker empty. It now loads the open jobs (/job/list/open, the
  // same list the purchase-order line picker uses). If the full list is already
  // in the store from another screen it is used instead, as it's a superset.
  const { allJobsList, openJobsList } = useSelector((state) => ({
    allJobsList: state.Jobs.jobsData?.job_list,
    openJobsList: state.Jobs.jobsOpenListData?.job_list,
  }));
  const jobsList = !isEmpty(allJobsList) ? allJobsList : openJobsList || [];

  const { attachmentCategoryTypeList } = useSelector((state) => ({
    attachmentCategoryTypeList:
      state.AttachmentCategoryType.attachmentCategoryTypeList
        ?.attachmentcategorytype_list ??
      state.AttachmentCategoryType.attachmentCategoryTypeList
        ?.jobattachmenttype_list,
  }));

  useEffect(() => {
    if (isEmpty(jobsList)) {
      dispatch(getJobsOpenList());
    }
    if (isEmpty(attachmentCategoryTypeList)) {
      dispatch(getAttachmentCategoryTypeData());
    }
  }, []);

  const [addingFile, setAddingFile] = useState(false);

  // Drag-and-drop state. `dragDepth` counts enter/leave pairs: dragging over a
  // child element fires dragleave on the parent, so a simple boolean flickers
  // the highlight off as the cursor crosses the zone's own contents.
  const [isDragging, setIsDragging] = useState(false);
  const dragDepth = useRef(0);
  const fileInputRef = useRef(null);

  // Shared ingest path for both the file picker and a drop. Takes anything
  // FileList-like so the two entry points can't drift apart.
  const addFiles = useCallback(
    (fileList) => {
      const files = Array.from(fileList || []);
      if (!files.length) return;

      setAddingFile(true);

      let pending = files.length;
      // Always decrement through here — if a read fails and we only counted
      // down on success, the "Adding file..." spinner would hang forever.
      const settle = () => {
        pending--;
        if (pending === 0) setAddingFile(false);
      };

      files.forEach((file) => {
        const reader = new FileReader();
        reader.readAsDataURL(file);

        reader.onerror = () => {
          toast.error(`Could not read "${file.name}"`);
          settle();
        };

        reader.onloadend = () => {
          const base64String = reader.result;

          const fileObj = {
            FileName: file.name,
            Name: file.name,
            Description: "",
            Notes: "",
            FileType: file.type,
            FileLastModifiedDateTime: moment(file.lastModified).format(
              "YYYY-MM-DD HH:mm:ss"
            ),
            FileSizeBytes: file.size,
            FileBase64: base64String,
            AttachmentCategoryType_Id: null,
            // Auto-link to Job if provided (Job flow)
            linked_job: singleJobAttachment
              ? [{ Id: singleJobAttachment }]
              : [],
            // Auto-link to Task if provided (Task flow)
            linked_task: taskDetailsAttachment
              ? [{ Id: taskDetailsAttachment }]
              : [],
            // Auto-link to Opportunity if provided (Opportunity flow)
            linked_opportunity: opportunityDetailsAttachment
              ? [{ Id: opportunityDetailsAttachment }]
              : [],
            // Auto-link to Supplier if provided (Supplier flow)
            linked_supplier: supplierDetailsAttachment
              ? [{ Id: supplierDetailsAttachment }]
              : [],
            // Auto-link to Company Vehicle if provided (Company Vehicle flow)
            linked_companyvehicle: companyVehicleDetailsAttachment
              ? [{ Id: companyVehicleDetailsAttachment }]
              : [],
            // Auto-link to Asset if provided (Asset flow)
            linked_asset: assetDetailsAttachment
              ? [{ Id: assetDetailsAttachment }]
              : [],
            // Auto-link to Food Pre-Order Event if provided (Pre-Order flow)
            linked_foodpreorderevent: foodPreOrderEventDetailsAttachment
              ? [{ Id: foodPreOrderEventDetailsAttachment }]
              : [],
            // Auto-link to Bank Account as a general document (letters, overdraft
            // requests, correspondence). No period.
            linked_bankaccount: bankAccountDetailsAttachment
              ? [{ Id: bankAccountDetailsAttachment }]
              : [],
            // Auto-link to Bank Account as a statement. Carries the statement
            // period so it can be found again easily.
            linked_bankaccountstatement: bankAccountStatementDetailsAttachment
              ? [
                  {
                    Id: bankAccountStatementDetailsAttachment,
                    PeriodStartDate: "",
                    PeriodEndDate: "",
                  },
                ]
              : [],
            collapse: bankAccountStatementDetailsAttachment ? false : true,
          };

          setJobMultipleFiles((prev) => [...prev, fileObj]);
          settle();
        };
      });
    },
    [
      singleJobAttachment,
      taskDetailsAttachment,
      opportunityDetailsAttachment,
      supplierDetailsAttachment,
      companyVehicleDetailsAttachment,
      assetDetailsAttachment,
      foodPreOrderEventDetailsAttachment,
      bankAccountDetailsAttachment,
      bankAccountStatementDetailsAttachment,
    ]
  );

  const handleMultipleFiles = (e) => {
    addFiles(e.target.files);
    // Reset so picking the SAME file again still fires onChange.
    e.target.value = "";
  };

  const openFilePicker = () => fileInputRef.current?.click();

  // Only react to an actual file drag — dragging text or an image from another
  // page shouldn't light the zone up.
  const isFileDrag = (e) =>
    Array.from(e.dataTransfer?.types || []).includes("Files");

  const onDragEnter = (e) => {
    if (!isFileDrag(e)) return;
    e.preventDefault();
    dragDepth.current += 1;
    setIsDragging(true);
  };

  const onDragOver = (e) => {
    if (!isFileDrag(e)) return;
    // Without preventDefault the browser navigates to the file instead of
    // letting us handle the drop.
    e.preventDefault();
    e.dataTransfer.dropEffect = "copy";
  };

  const onDragLeave = (e) => {
    if (!isFileDrag(e)) return;
    e.preventDefault();
    dragDepth.current = Math.max(0, dragDepth.current - 1);
    if (dragDepth.current === 0) setIsDragging(false);
  };

  const onDrop = (e) => {
    if (!isFileDrag(e)) return;
    e.preventDefault();
    dragDepth.current = 0;
    setIsDragging(false);
    addFiles(e.dataTransfer.files);
  };

  const handleUpload = () => {
    if (isEmpty(jobMultipleFiles))
      return toast.error("Please select files to upload");

    if (page === "PurchaseListPage") {
      dispatch(uploadPurchaseDraft(jobMultipleFiles));
      return;
    }

    // If uploading for a Task/Opportunity/Supplier/CompanyVehicle/PreOrderEvent, strip any linked_job to avoid mixing Job attachments
    const filesToSend =
      taskDetailsAttachment ||
      opportunityDetailsAttachment ||
      supplierDetailsAttachment ||
      companyVehicleDetailsAttachment ||
      assetDetailsAttachment ||
      foodPreOrderEventDetailsAttachment ||
      bankAccountDetailsAttachment ||
      bankAccountStatementDetailsAttachment
        ? jobMultipleFiles.map((f) => ({ ...f, linked_job: [] }))
        : jobMultipleFiles;

    dispatch(uploadJobFiles(filesToSend));
  };

  const {
    multipleJobFilesAPI,
    multipleJobFilesLoadingAPI,
    uploadPurchaseDraftSuccessAPI,
    uploadPurchaseDraftSuccessLoading,
  } = useSelector((state) => ({
    multipleJobFilesAPI: state.Jobs.multipleJobFiles,
    multipleJobFilesLoadingAPI: state.Jobs.multipleJobFilesLoading,
    uploadPurchaseDraftSuccessAPI: state.Purchase.uploadPurchaseDraftSuccess,
    uploadPurchaseDraftSuccessLoading:
      state.Purchase.uploadPurchaseDraftSuccessLoading,
  }));

  useEffect(() => {
    if (isEmpty(multipleJobFilesAPI)) return;
    if (multipleJobFilesAPI?.status === 200) {
      toast.success(multipleJobFilesAPI?.message);
      if (singleJobAttachment) {
        const data = [
          {
            jobattachment_data: {
              Job_Id: singleJobAttachment,
            },
          },
        ];
        dispatch(searchSingleJobFilesList(data));
      }
      if (taskDetailsAttachment) {
        const data = [
          {
            taskattachment_data: {
              Task_Id: taskDetailsAttachment,
            },
          },
        ];
        dispatch(searchTaskAttachmentList(data));
      }
      if (opportunityDetailsAttachment) {
        const data = [
          {
            opportunityattachment_data: {
              Opportunity_Id: opportunityDetailsAttachment,
            },
          },
        ];
        dispatch(searchOpportunityAttachmentList(data));
      }
      if (supplierDetailsAttachment) {
        const data = [
          {
            supplierattachment_data: {
              Supplier_Id: supplierDetailsAttachment,
            },
          },
        ];
        dispatch(searchSupplierAttachment(data));
      }
      if (companyVehicleDetailsAttachment) {
        const data = [
          {
            companyvehicleattachment_data: {
              CompanyVehicle_Id: companyVehicleDetailsAttachment,
            },
          },
        ];
        dispatch(searchCompanyVehicleAttachment(data));
        // attachments feed into the recent-activity list too
        dispatch(
          listCompanyVehicleRecentActivity({
            id: companyVehicleDetailsAttachment,
          })
        );
      }
      if (assetDetailsAttachment) {
        dispatch(
          assetAttachmentSearch([
            { assetattachment_data: { Asset_Id: assetDetailsAttachment } },
          ])
        );
        // attachments feed into the recent-activity list too
        dispatch(assetRecentActivityList({ id: assetDetailsAttachment }));
      }
      if (foodPreOrderEventDetailsAttachment) {
        const data = [
          {
            foodpreordereventattachment_data: {
              FoodPreOrderEvent_Id: foodPreOrderEventDetailsAttachment,
            },
          },
        ];
        dispatch(foodPreOrderEventAttachmentSearch(data));
        // attachments feed into the recent-activity list too
        dispatch(
          foodPreOrderEventRecentActivityList({
            id: foodPreOrderEventDetailsAttachment,
          })
        );
      }
      if (bankAccountDetailsAttachment) {
        const data = [
          {
            bankaccountattachment_data: {
              BankAccount_Id: bankAccountDetailsAttachment,
            },
          },
        ];
        dispatch(searchBankAccountAttachment(data));
      }
      if (bankAccountStatementDetailsAttachment) {
        const data = [
          {
            bankaccountstatement_data: {
              BankAccount_Id: bankAccountStatementDetailsAttachment,
            },
          },
        ];
        dispatch(searchBankAccountStatement(data));
      }
      setModal(false);
      setJobMultipleFiles(jobMultipleFilesInit);
    } else {
      toast.error(multipleJobFilesAPI?.message);
    }
    dispatch(uploadJobFilesSuccess([]));
  }, [multipleJobFilesAPI]);

  useEffect(() => {
    if (isEmpty(uploadPurchaseDraftSuccessAPI)) return;
    if (uploadPurchaseDraftSuccessAPI?.status === 200) {
      toast.success(uploadPurchaseDraftSuccessAPI?.message);
      setModal(false);
      setJobMultipleFiles(jobMultipleFilesInit);
      callBack && callBack();
    } else {
      toast.error(uploadPurchaseDraftSuccessAPI?.message);
    }
    dispatch(uploadPurchaseDraftSuccess([]));
  }, [uploadPurchaseDraftSuccessAPI]);

  const isUploading =
    multipleJobFilesLoadingAPI || uploadPurchaseDraftSuccessLoading;

  const totalSizeLabel = jobMultipleFiles.length
    ? formatBytes(
        jobMultipleFiles.reduce(
          (sum, f) => sum + (Number(f.FileSizeBytes) || 0),
          0
        )
      )
    : "";

  return (
    <>
      <AppModal
        open={modal}
        onClose={toggle}
        title="Upload Files"
        icon={<UploadFileOutlinedIcon />}
        headerAccent="indigo"
        size="sm"
        loading={isUploading}
        loadingText="Please wait while your files are being uploaded…"
        onSubmit={handleUpload}
        submitLabel="Upload"
        submitColor="primary"
        submitDisabled={isUploading}
      >
            <Row className="g-3">
              {/* Upload multiple files — drag & drop, or click to browse */}
              <Col md={12}>
                <Label className="form-label">Upload Multiple Files</Label>

                <div
                  className={`file-dropzone${
                    isDragging ? " file-dropzone--active" : ""
                  }`}
                  onDragEnter={onDragEnter}
                  onDragOver={onDragOver}
                  onDragLeave={onDragLeave}
                  onDrop={onDrop}
                  onClick={openFilePicker}
                  // Keyboard parity: the zone is the control now, so it has to
                  // be reachable and operable without a mouse.
                  role="button"
                  tabIndex={0}
                  onKeyDown={(e) => {
                    if (e.key === "Enter" || e.key === " ") {
                      e.preventDefault();
                      openFilePicker();
                    }
                  }}
                  aria-label="Drag and drop files here, or click to browse"
                >
                  <i className="fa-solid fa-cloud-arrow-up file-dropzone__icon"></i>
                  <div className="file-dropzone__title">
                    {isDragging
                      ? "Drop your files to add them"
                      : "Drag & drop files here"}
                  </div>
                  <div className="file-dropzone__hint">
                    or <span className="file-dropzone__link">browse</span> from
                    your computer — you can add several at once
                  </div>
                </div>

                <Input
                  type="file"
                  className="d-none"
                  id="multipleFiles"
                  innerRef={fileInputRef}
                  multiple
                  onChange={handleMultipleFiles}
                />

                {totalSizeLabel && (
                  <div className="text-muted small mt-2">
                    {jobMultipleFiles.length} file
                    {jobMultipleFiles.length === 1 ? "" : "s"} ready ·{" "}
                    {totalSizeLabel}
                  </div>
                )}
              </Col>

              {/* Files preview + linking */}
              <Col md={12}>
                {jobMultipleFiles.length > 0 && <h5>Files list</h5>}
                {addingFile && (
                  <div className="d-flex align-items-center mb-2 text-muted">
                    <i className="fa-solid fa-spinner fa-spin me-2"></i>
                    Adding file...
                  </div>
                )}

                <div>
                  {jobMultipleFiles.map((file, index) => (
                    <Card
                      key={index}
                      className={"p-2"}
                      style={{ boxShadow: "0 0 5px rgba(0,0,0,0.2)" }}
                    >
                      <div
                        className={"cursor-pointer"}
                        onClick={() => {
                          setJobMultipleFiles((prevState) =>
                            prevState.map((item, index5) =>
                              index5 === index
                                ? { ...item, collapse: !item?.collapse }
                                : item
                            )
                          );
                        }}
                      >
                        <div>
                          <i className="fa-solid fa-file me-1"></i>
                          File name: <span>{file.FileName}</span>
                          {formatBytes(file.FileSizeBytes) && (
                            <span className="text-muted ms-2">
                              ({formatBytes(file.FileSizeBytes)})
                            </span>
                          )}
                        </div>
                        <div className={"colapsable-icon-for-file-upload"}>
                          {file?.collapse ? (
                            <i
                              title={"Click to expand"}
                              className={"fa-solid fa-chevron-down"}
                            ></i>
                          ) : (
                            <i
                              title={"Click to collapse"}
                              className={"fa-solid fa-chevron-up"}
                            ></i>
                          )}
                        </div>
                      </div>

                      {!file?.collapse && (
                        <div>
                          <div className={"pt-2"}>
                            <div>
                              <Label>File Name</Label>
                              <Input
                                type="text"
                                placeholder="File Name"
                                value={file?.FileName}
                                onChange={(e) => {
                                  setJobMultipleFiles((prevState) =>
                                    prevState.map((item, index5) =>
                                      index5 === index
                                        ? { ...item, FileName: e.target.value }
                                        : item
                                    )
                                  );
                                }}
                              />
                            </div>
                            <div>
                              <Label>Notes</Label>
                              <Input
                                type="text"
                                placeholder="Notes"
                                value={file?.Notes}
                                onChange={(e) => {
                                  setJobMultipleFiles((prevState) =>
                                    prevState.map((item, index5) =>
                                      index5 === index
                                        ? { ...item, Notes: e.target.value }
                                        : item
                                    )
                                  );
                                }}
                              />
                            </div>

                            {/* Attachment Category (optional, Job and Task flows only) */}
                            {page !== "PurchaseListPage" && (
                              <div>
                                <Label>Attachment Category</Label>
                                <Select
                                  placeholder={"Select Attachment Category"}
                                  className="mb-0 job-select2"
                                  isClearable
                                  value={
                                    file?.AttachmentCategoryType_Id
                                      ? {
                                          label:
                                            attachmentCategoryTypeList?.find(
                                              (item) =>
                                                item.Id ===
                                                file?.AttachmentCategoryType_Id
                                            )?.Name,
                                          value:
                                            file?.AttachmentCategoryType_Id,
                                          id: file?.AttachmentCategoryType_Id,
                                        }
                                      : null
                                  }
                                  onChange={(e) => {
                                    setJobMultipleFiles((prevState) =>
                                      prevState.map((item, index5) =>
                                        index5 === index
                                          ? {
                                              ...item,
                                              AttachmentCategoryType_Id:
                                                e?.id || null,
                                            }
                                          : item
                                      )
                                    );
                                  }}
                                  options={
                                    !isEmpty(attachmentCategoryTypeList)
                                      ? attachmentCategoryTypeList?.map(
                                          (item) => ({
                                            label: item?.Name,
                                            value: item?.Id,
                                            id: item?.Id,
                                          })
                                        )
                                      : []
                                  }
                                ></Select>
                              </div>
                            )}

                            {/* Task auto-link badge */}
                            {taskDetailsAttachment && (
                              <div className="pt-2">
                                <span className="badge badge-soft-success">
                                  Auto-linked to Task #{taskDetailsAttachment}
                                </span>
                              </div>
                            )}

                            {/* Opportunity auto-link badge */}
                            {opportunityDetailsAttachment && (
                              <div className="pt-2">
                                <span className="badge badge-soft-success">
                                  Auto-linked to Opportunity #
                                  {opportunityDetailsAttachment}
                                </span>
                              </div>
                            )}

                            {/* Supplier auto-link badge */}
                            {supplierDetailsAttachment && (
                              <div className="pt-2">
                                <span className="badge badge-soft-success">
                                  Auto-linked to Supplier #
                                  {supplierDetailsAttachment}
                                </span>
                              </div>
                            )}

                            {/* Pre-Order Event auto-link badge */}
                            {foodPreOrderEventDetailsAttachment && (
                              <div className="pt-2">
                                <span className="badge badge-soft-success">
                                  Auto-linked to Pre-Order #
                                  {foodPreOrderEventDetailsAttachment}
                                </span>
                              </div>
                            )}

                            {/* Bank account general-document auto-link badge (letters, overdraft requests) */}
                            {bankAccountDetailsAttachment && (
                              <div className="pt-2">
                                <span className="badge badge-soft-success">
                                  Auto-linked to Bank #
                                  {bankAccountDetailsAttachment}
                                </span>
                              </div>
                            )}

                            {/* Bank statement auto-link badge + statement period */}
                            {bankAccountStatementDetailsAttachment && (
                              <>
                                <div className="pt-2">
                                  <span className="badge badge-soft-success">
                                    Statement for Bank #
                                    {bankAccountStatementDetailsAttachment}
                                  </span>
                                </div>
                                <Row className="pt-2">
                                  <Col md={6}>
                                    <Label>Statement Period Start</Label>
                                    <Input
                                      type="date"
                                      value={
                                        file?.linked_bankaccountstatement?.[0]
                                          ?.PeriodStartDate || ""
                                      }
                                      onChange={(e) => {
                                        const value = e.target.value;
                                        setJobMultipleFiles((prevState) =>
                                          prevState.map((item, index5) =>
                                            index5 === index
                                              ? {
                                                  ...item,
                                                  linked_bankaccountstatement: [
                                                    {
                                                      ...(item
                                                        ?.linked_bankaccountstatement?.[0] ||
                                                        {
                                                          Id: bankAccountStatementDetailsAttachment,
                                                        }),
                                                      PeriodStartDate: value,
                                                    },
                                                  ],
                                                }
                                              : item
                                          )
                                        );
                                      }}
                                    />
                                  </Col>
                                  <Col md={6}>
                                    <Label>Statement Period End</Label>
                                    <Input
                                      type="date"
                                      value={
                                        file?.linked_bankaccountstatement?.[0]
                                          ?.PeriodEndDate || ""
                                      }
                                      onChange={(e) => {
                                        const value = e.target.value;
                                        setJobMultipleFiles((prevState) =>
                                          prevState.map((item, index5) =>
                                            index5 === index
                                              ? {
                                                  ...item,
                                                  linked_bankaccountstatement: [
                                                    {
                                                      ...(item
                                                        ?.linked_bankaccountstatement?.[0] ||
                                                        {
                                                          Id: bankAccountStatementDetailsAttachment,
                                                        }),
                                                      PeriodEndDate: value,
                                                    },
                                                  ],
                                                }
                                              : item
                                          )
                                        );
                                      }}
                                    />
                                  </Col>
                                </Row>
                              </>
                            )}

                            {/* Link a Job (hidden when uploading for a Task/Opportunity/Supplier/PreOrderEvent/BankAccount/BankStatement) */}
                            {!taskDetailsAttachment &&
                              !opportunityDetailsAttachment &&
                              !supplierDetailsAttachment &&
                              !foodPreOrderEventDetailsAttachment &&
                              !bankAccountDetailsAttachment &&
                              !bankAccountStatementDetailsAttachment && (
                              <>
                                <div className={"pt-2"}>
                                  <span className={"badge badge-soft-primary"}>
                                    + Link a Job{" "}
                                  </span>
                                </div>
                                <div>
                                  <Select
                                    placeholder={"Select Job"}
                                    className="mb-0 job-select2"
                                    value={
                                      !isEmpty(file?.linked_job) &&
                                      !isEmpty(file?.linked_job[0]?.Id)
                                        ? {
                                            label:
                                              "#" +
                                              file?.linked_job[0]?.Id +
                                              " " +
                                              jobsList.find(
                                                (item) =>
                                                  item.Id ===
                                                  file?.linked_job[0]?.Id
                                              )?.Title,
                                            value: file?.linked_job[0]?.Id,
                                            id: file?.linked_job[0]?.Id,
                                          }
                                        : []
                                    }
                                    onChange={(e) => {
                                      setJobMultipleFiles((prevState) =>
                                        prevState.map((item, index5) =>
                                          index5 === index
                                            ? {
                                                ...item,
                                                linked_job: [
                                                  ...(item?.linked_job || []),
                                                  { Id: e?.id },
                                                ],
                                              }
                                            : item
                                        )
                                      );
                                    }}
                                    options={
                                      !isEmpty(jobsList)
                                        ? jobsList?.map((item) => ({
                                            label:
                                              "#" +
                                              item?.Id +
                                              " " +
                                              item?.Title,
                                            value: item?.Id,
                                            id: item?.Id,
                                          }))
                                        : []
                                    }
                                    id="country-select"
                                  ></Select>
                                </div>
                              </>
                            )}

                            <div className={"mt-2"}>
                              <button
                                className={"btn btn-sm btn-danger"}
                                onClick={() => {
                                  setJobMultipleFiles((prevState) =>
                                    prevState.filter(
                                      (_, index5) => index5 !== index
                                    )
                                  );
                                }}
                              >
                                Remove
                              </button>
                            </div>
                          </div>

                          {/* Linked Jobs list (hidden when uploading for a Task/Opportunity/Supplier/PreOrderEvent/BankAccount/BankStatement) */}
                          {!taskDetailsAttachment &&
                            !opportunityDetailsAttachment &&
                            !supplierDetailsAttachment &&
                            !foodPreOrderEventDetailsAttachment &&
                            !bankAccountDetailsAttachment &&
                            !bankAccountStatementDetailsAttachment && (
                            <div className={"pt-2"}>
                              {file?.linked_job.length > 0 && (
                                <h6>Linked Jobs:</h6>
                              )}
                              {file?.linked_job.map((job, index2) => (
                                <div key={index2}>
                                  {job.Id && (
                                    <span>
                                      #{job.Id}{" "}
                                      {(() => {
                                        const t =
                                          jobsList.find((i) => i.Id === job.Id)
                                            ?.Title || "";
                                        return t.length > 50
                                          ? t.substring(0, 50) + "..."
                                          : t;
                                      })()}
                                      <span
                                        title={"Remove Linked Job"}
                                        className={"btn text-danger"}
                                        onClick={() => {
                                          setJobMultipleFiles((prevState) =>
                                            prevState.map((item, index5) =>
                                              index5 === index
                                                ? {
                                                    ...item,
                                                    linked_job: (
                                                      item?.linked_job || []
                                                    ).filter(
                                                      (lj) => lj.Id !== job.Id
                                                    ),
                                                  }
                                                : item
                                            )
                                          );
                                        }}
                                      >
                                        <i className="fa-solid fa-trash-can"></i>
                                      </span>
                                    </span>
                                  )}
                                  <hr className={"pt-1 pb-1 mt-1 mb-1"} />
                                </div>
                              ))}
                            </div>
                          )}
                        </div>
                      )}
                    </Card>
                  ))}
                </div>
              </Col>

            </Row>
      </AppModal>
    </>
  );
}
